import { type SvgIcon } from '@mui/material';
import { AcUnit, Air, LocalFireDepartment } from '@mui/icons-material';

import {
  type FuelType,
  type RatingUnit,
} from '#packages/data-collection/models/audit-mechanical-form';
import { type System } from '#packages/data-collection/models/common/system';
import { type Source } from '#packages/data-collection/models/common/sources';

export const SystemLabel: Record<System, string> = {
  space_heating: 'Space Heating',
  space_cooling: 'Space Cooling',
  ventilation: 'Ventilation',
  domestic_hot_water: 'Domestic Hot Water',
  mechanical: 'Mechanical',
  plug_loads: 'Plug Loads',
  appliances: 'Appliances',
  on_site_generation: 'Onsite Generation',
  other: 'Other',
} as const;

export const RatingUnitLabel: Record<RatingUnit, string> = {
  kw: 'kW',
  hp: 'hp',
  btu_per_hour: 'BTU/h',
  gph_gallon_per_hour: 'gph (gal/h)',
  tons_cooling: 'tons (cooling)',
};

export const SourceLabel: Record<Source, string> = {
  nameplate: 'Nameplate',
  drawing: 'Drawing',
  past_report: 'Past report',
  site_contact: 'Site contact',
  flue_gas_analyzer: 'Flue gas analyzer',
  guess: 'Guess',
};

export type UtilityType =
  | 'electricity'
  | 'natural_gas'
  | 'propane'
  | 'heating_oil'
  | 'heavy_fuel_oil'
  | 'diesel'
  | 'gasoline'
  | 'kerosene'
  | 'wood'
  | 'tenant_electricity';

export const UtilityTypeLabel: Record<UtilityType, string> = {
  electricity: 'Electricity',
  natural_gas: 'Natural Gas',
  propane: 'Propane',
  heating_oil: 'Heating Oil',
  heavy_fuel_oil: 'Hvy. Fuel Oil',
  diesel: 'Diesel',
  gasoline: 'Gasoline',
  kerosene: 'Kerosene',
  wood: 'Wood',
  tenant_electricity: 'Tenant Electricity',
};

export const DefaultUtilityTypeValue: Partial<Record<UtilityType, number>> = {
  propane: 0.0254,
  heating_oil: 0.0388,
  heavy_fuel_oil: 0.0425,
  diesel: 0.03835,
  gasoline: 0.03345,
  kerosene: 0.03768,
};

export const FuelTypeLabel: Record<FuelType, string> = {
  natural_gas: 'Natural gas',
  electricity: 'Electricity',
};

export const SystemIcon: Record<System, typeof SvgIcon> = {
  space_heating: LocalFireDepartment,
  space_cooling: AcUnit,
  ventilation: Air,
  domestic_hot_water: LocalFireDepartment,
  appliances: LocalFireDepartment,
  mechanical: LocalFireDepartment,
  on_site_generation: LocalFireDepartment,
  plug_loads: LocalFireDepartment,
  other: LocalFireDepartment,
};

export const getSuiteTypeLabel = (roomNumber: number) =>
  roomNumber === 0 ? 'Bachelor' : `${roomNumber} Bedroom`;
